import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { HttpService } from '../../../http.service';
import { DataServiceService } from '../../../services/data-service.service';
import { DxButtonModule, DxButtonTypes } from 'devextreme-angular/ui/button';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DxFormComponent, DxFormModule } from 'devextreme-angular';
import { Merchant, TopupMerchantWallet } from '../../home/models';
import notify from 'devextreme/ui/notify';
import { KeycloakService } from 'keycloak-angular';
import { WalletDto } from '../../../components/utils/models/walletDto';
import ODataStore from 'devextreme/data/odata/store';
import { ODataMerchant } from '../../../components/utils/models/ODataMerchant';
import { MerchantGridRecord } from '../../../components/utils/models/MerchantGridRecord';
import dxButton from 'devextreme/ui/button';
import dxForm from 'devextreme/ui/form';
import { catchError, Observable, of } from 'rxjs';
import { TopupMerchantWalletResult } from '../../../components/utils/models/topup-merchant-wallet-result';
import { UtilityFunctions } from '../../../shared/helpers/utility-functions';
import { ApiError } from '../../../components/utils/models/api-error';
import { HttpErrorResponse } from '@angular/common/http';
import { getSizeQualifier, ScreenService } from '../../../services';
import DataSource from 'devextreme/data/data_source';

interface FormLayout {
  amount: number,
  merchant: MerchantGridRecord | null,
  walletId: number
}

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, DxButtonModule, DxFormModule, CommonModule],
  selector: 'app-topup-merchant-wallet',
  templateUrl: './topup-merchant-wallet.component.html',
  styleUrl: './topup-merchant-wallet.component.scss'
})
export class TopupMerchantWalletComponent {
  @Input() colCount: number = 2;
  formData: FormLayout = {
    amount: 0,
    merchant: null,
    walletId: 0,
  };

  numberBoxOptions = {
    showClearButton: true,
    format: "R #,##0.00",
    value: this.formData.amount,
    valueChangeEvent: 'input',
    onValueChanged: (e: any) => {
      this.formData.amount = e.value;
    },
    step : 0
  };

  merchantsDataSource: any;
  priceListData: any;

  selectedMerchant: ODataMerchant | null = null;
  selectedMerchantId = -1;
  selectedWallet: WalletDto | null = null;
  walletList: WalletDto[] = [];
  walletMap: Map<number, WalletDto>;
  merchantList: ODataMerchant[]
  merchantMap: Map<number, ODataMerchant>;
  UserKeycloakGuidId: any;
  formValid = false;
  getSizeQualifier = getSizeQualifier;

  @ViewChild('MerchantwalletForm', { static: false }) merchantWalletFormComponent!: DxFormComponent;

  constructor(private httpService: HttpService, private dataService: DataServiceService,private ref : ChangeDetectorRef,  private keycloakService : KeycloakService, public screen: ScreenService) {  
    this.merchantsDataSource = this.dataService.getQuickActionsMerchantDataSource();
    this.walletMap = new Map<number, WalletDto>();
    this.merchantList = [];
    this.merchantMap = new Map<number, ODataMerchant>();
    this.initData();
    
    this.keycloakService
      .loadUserProfile()
      .then(e => {
        this.UserKeycloakGuidId = e.id!;
      });
  }

  async initData() {
    await this.merchantsDataSource.load().then(data => {
      this.merchantList = data;
      this.merchantList = this.merchantList.sort((a, b) => {
        return a.CompanyName.localeCompare(b.CompanyName)
      });
      this.merchantMap.clear()
      data.map(d => this.merchantMap.set((d as ODataMerchant).Id, (d as ODataMerchant)))
    }).catch(error => {
      console.error('Error loading data', error);
    });
  }

  submitButtonOptions: DxButtonTypes.Properties = {
    text: 'Submit',
    type: 'default',
    width: '120px',
    useSubmitBehavior: true,
    disabled: false
  };


  onFormSubmit = (e: SubmitEvent) => {
    this.submitButtonOptions.disabled  = true;
    let data = new TopupMerchantWallet(this.selectedMerchantId, this.formData.walletId, this.formData.amount,this.UserKeycloakGuidId);
    this.httpService.topupMerchantWallet(data)
    .pipe(catchError((error: HttpErrorResponse, caught: Observable<TopupMerchantWalletResult>): Observable<TopupMerchantWalletResult> => {
      UtilityFunctions.showErrorMessage(error);
      return of();
    }))
    .subscribe(res => {
      if (res.status == 'success')
        {
          UtilityFunctions.showMessage("Merchant wallet successfully topped up", "success");
      } else {
        UtilityFunctions.showMessage("Merchant wallet not topped up. Unknown error", "error");
      }
      this.resetFormFields();
      
    });
    e.preventDefault();
  };

  onFieldChange(fieldName?, value?, event?: any) {
    let validationResult = this.merchantWalletFormComponent.instance.validate()
    this.formValid = validationResult.isValid!;

    if (event?.dataField == "selectedMerchantId") {
      this.selectedMerchant = this.merchantMap.get(event.value)!
      this.selectedMerchantId = event.value;
      
      this.httpService.getWalletsByMerchant(event.value).subscribe(res => {
        this.walletMap.clear();
        this.walletList = [];
        this.selectedWallet = null;
        this.walletList = res;
        this.walletList = this.walletList.sort((a, b) => {
          return a.name.localeCompare(b.name)
        });
        this.walletList.map(wallet => this.walletMap.set(wallet.id, wallet));
        this.formData['walletId'] = 0
        this.merchantWalletFormComponent.instance.getEditor('amount')?.reset();
        
      });

      
    }

    if (event?.dataField == "walletId") {
      this.formData['walletId'] = 0
      this.merchantWalletFormComponent.instance.getEditor('amount')?.reset();

      this.formData.walletId = event.value;
      this.selectedWallet = this.walletMap.get(event.value)!;
    }
  }

  async resetFormFields() {
    
    
    this.merchantWalletFormComponent.instance.reset();
    this.merchantWalletFormComponent.instance.clear();
    this.formData['selectedMerchantId'] = 0
    await this.initData()
    
    this.formValid = false;
    this.submitButtonOptions.disabled  = false;
  }

  handleMerchantsBalanceUpdate(data: number) {
    let previousstateDropdownMerchantId =  this.selectedMerchantId 
    let previousstateDrodownWalletId = this.formData.walletId
    //this.resetFormFields();
    
    this.merchantsDataSource = this.dataService.getQuickActionsMerchantDataSource();
    this.walletMap = new Map<number, WalletDto>();
    this.merchantList = [];
    this.merchantMap = new Map<number, ODataMerchant>();
    this.initData().then(()=>{

      if (previousstateDropdownMerchantId != null) {
        this.selectedMerchant = this.merchantMap.get(previousstateDropdownMerchantId)!
        this.selectedMerchantId = previousstateDropdownMerchantId;
        
        this.httpService.getWalletsByMerchant(previousstateDropdownMerchantId).subscribe(res => {
          this.walletMap.clear();
          this.walletList = [];
          this.selectedWallet = null;
          this.walletList = res;
          this.walletList = this.walletList.sort((a, b) => {
            return a.name.localeCompare(b.name)
          });
          this.walletList.map(wallet => this.walletMap.set(wallet.id, wallet));

          if (previousstateDrodownWalletId != null) {
            this.formData.walletId = previousstateDrodownWalletId;
            this.selectedWallet = this.walletMap.get(previousstateDrodownWalletId)!;
            
          }
          
        });
      }

    });
  

  }

}
